import $ from 'jquery'
$(document).ready(function () {

    function syncShellSidebarOnLoad() {
        var $sidebar = $('.page-sidebar');
        var $header = $('.page-main-header');
        if (!$sidebar.length) {
            return;
        }
        if (window.innerWidth <= 991) {
            $sidebar.addClass('close_icon');
            $header.addClass('close_icon');
        } else {
            $sidebar.removeClass('close_icon');
            $header.removeClass('close_icon');
        }
    }
    setTimeout(syncShellSidebarOnLoad, 0);
    $(window).on('resize', syncShellSidebarOnLoad);
    $('body').on('click', '.action_icon', function () {
        $('td.p-frozen-column').removeClass('openedActionBox');
        $(this).closest('td.p-frozen-column').addClass('openedActionBox');

        $(".action-list-box").animate({
            width: "0px",
        }, 100);

        var spnid = $(this).attr("attribute-id");
        var length = ($(".sixelement" + spnid).find('a').length);

        var dWidth = parseInt((61 * length) + 32);

        $(".spn" + spnid).animate({
            width: "310px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        //fsm-list
        $(".style_class").animate({
            'width': dWidth + "px",
        }, 200);
        $(".sixelement" + spnid).animate({
            'width': dWidth + "px",


        }, 200);
        $(".sevenelement" + spnid).animate({
            width: "350px",

        }, 200);
    });
    $('body').on('click', '.close-action', function () {

        $(this).closest('td.p-frozen-column').removeClass('openedActionBox');


        $(".action-list-box").animate({
            width: "0px",

        }, 100);
    });


    $('body').on('click', '.action_icon_Demo', function () {
        $(this).parents("td").addClass("openAction");

        $(".action-list-box").animate({
            width: "0px",
        }, 100);
        var innerWidth = 0;
        var halfwidth = 0;
        var dWidth = 0;
        var spnid = $(this).attr("attribute-id");
        //var dWidth = parseInt((80 * length) + 32);
        var aTags = $(".sixelement" + spnid).find('a');
        aTags.each(function (index) {
            dWidth += $(this).outerWidth(); // Includes padding
            halfwidth = dWidth + 60;
            innerWidth = halfwidth;

        });

            $(".spn" + spnid).animate({
                'width': innerWidth + "px",
            }, 200);
            $(".sixelement" + spnid).animate({
                'width': innerWidth + "px",

            }, 200);
            //fsm-list
            $(".style_class").animate({
                'width': innerWidth + "px",
            }, 200);
            $(".sixelement" + spnid).animate({
                'width': innerWidth + "px",

            }, 200);
            $(".sevenelement" + spnid).animate({
                width: "350px",

            }, 200);
        });
        $('body').on('click', '.action_new_Demo', function () {
            $(this).parents("td").addClass("openAction");

            $(".action-list-box").animate({
                width: "0px",
            }, 100);

            var spnid = $(this).attr("attribute-id");
            var length = ($(".sixelement" + spnid).find('a').length);
            var dWidth = parseInt((299) + 1);
            // dWidth = parseInt((61 * length) + 32);

            $(".spn" + spnid).animate({
                width: "250px",
            }, 200);
            $(".sixelement" + spnid).animate({
                'width': dWidth + "px",


            }, 200);
            //fsm-list
            $(".style_class").animate({
                'width': dWidth + "px",
            }, 200);
            $(".sixelement" + spnid).animate({
                'width': dWidth + "px",


            }, 200);
            $(".sevenelement" + spnid).animate({
                width: "250px",

            }, 200);
        });


        $('body').on('click', '.close-action_Demo', function () {


            $(".action-list-box").animate({
                width: "0px",

            }, 100);
        });


        $(document).on("click", ".profile-avatar", function () {

            $(this).toggleClass("profile-menu");

        });
    $('body').on('click', '.close-action', function () {
        $(".action-list-box").stop(true, true).animate({
            width: "0px"
        }, 100);
    });

      $('body').on('click', '.close-action', function () {
          $(".action_icon").stop(true, true).animate({
            width: "0px"
        }, 100);
    });



    $('body').on('click', '.action_icon_1', function () {
        $(this).parent("td").addClass("openBox");

        // Close any open action box first
        $(".action-list-box").stop(true, true).animate({ width: "0px" }, 100);

        let spnid = $(this).attr("attribute-id");

        let $actionBox = $(".sixelement" + spnid);
        let $actions = $actionBox.find("a:visible");
      

        let totalWidth = 0;

        // Calculate total width of visible actions
        $actions.each(function () {
            totalWidth += $(this).outerWidth(true);
        });

        // Extra space for close icon + padding
        totalWidth += 50;

        // Animate container width
        $actionBox.stop(true, true).animate({
            width: (totalWidth + 80) + "px"
        }, 200);

        // Optional wrapper if you are using it
        $(".spn" + spnid).stop(true, true).animate({
            width: totalWidth + "px"
        }, 200);

        // FSM list (if used)
        $(".style_class").stop(true, true).animate({
            width: totalWidth + "px"
        }, 200);
    });


        //nav-page-sidebar
        //page-sidebar close_icon

        // Sidebar active state is owned by Vue (Sidebar.vue). Do not strip/add `active` here.
        $(document).on("click", ".sub_moduleRoute", function () {
            var spnid = $(this).attr("attribute-id");
            $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
            $('.addhighlited_' + spnid).addClass("cust-active-module");
        });

        $(document).on("click", ".single_click ", function () {
            var spnid = $(this).attr("attribute-id");
            $(".sidebar-link, .sub_moduleRoute ").removeClass("cust-active-module");
            $('.menuElelment_' + spnid).addClass("cust-active-module");
        });
    })














